var map = {
	"./404-bg.webp": 50415,
	"./apartment.webp": 25516,
	"./black-week-banner-bg.webp": 78043,
	"./black-week-discount.webp": 39172,
	"./black-week-modal-bg-extension.webp": 46981,
	"./black-week-modal-bg.webp": 91432,
	"./christmas-discount-banner-bg.webp": 29081,
	"./christmas-discount-bg.webp": 51428,
	"./ecommerce-banner.webp": 84226,
	"./february-discount-banner-bg.webp": 67379,
	"./february-discount-modal-bg.webp": 41434,
	"./feeding.webp": 58010,
	"./gastro-voucher-delete-bg.webp": 16361,
	"./gastro-voucher-image.webp": 31268,
	"./house.webp": 36628,
	"./image-placeholder.webp": 8382,
	"./improvement-image-fallback.webp": 66347,
	"./local-for-benefits-owner-modal.webp": 73776,
	"./login-promo.webp": 92760,
	"./modal-image.webp": 68266,
	"./remove-improvement-modal-bg.webp": 1704,
	"./subscription-with-benefit.webp": 41123,
	"./warranty-image.webp": 5120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15336;